/**
 * Uplifted pieces of apps/web `utils/myOrderConstants` (mobile has no such file), seeded with only
 * the symbol the feature gate needs (`helpers/featureRestrictionHelper`: the Unvoid / Uncancel
 * rules).
 *
 * ⚠️ NOT the `ORDER_STATUSES` both apps' `utils/constants` declare — that one maps
 * `dispatched` / `processed` / `cancelled` / `created`. Same name, different object. Mobile's gate
 * read the `utils/constants` one, whose `CANCEL` / `VOID` are undefined, so its Unvoid and Uncancel
 * rules never matched a real sale.
 */
export const ORDER_STATUSES = {
  VOID: "voided",
  CANCEL: "cancelled",
};
